<div class="layout-wrapper" (click)="onLayoutClick()"
     [ngClass]="{'layout-horizontal': app.horizontalMenu,
                'layout-wrapper-static': staticMenuActive,
                'layout-rightpanel-active': rightPanelActive,
                'layout-topbar-mobile-active': topbarMobileMenuActive,
                'layout-megamenu-mobile-active': megaMenuMobileActive,
                'layout-sidebar-mobile-active': menuMobileActive,
                'p-input-filled': app.inputStyle === 'filled',
                'p-ripple-disabled': !app.ripple}" [class]="app.menuColor">




    <app-menu [roles]="roles"></app-menu>

    <div class="layout-main">
        <app-topbar [roles]="roles"></app-topbar>

        <app-rightpanel></app-rightpanel>

        <app-breadcrumb></app-breadcrumb>

        <div *ngIf="muestraAvisoDeuda" class="p-fluid">
            <p-messages [severity]="severidadAvisoDeuda">
                <ng-template pTemplate>
                    <img src="assets/resources/images/late-payment.png" width="32" />
                    <div class="grid grid-nogutter ml-2">
                        <div class="col-12 text-bold">{{tituloAvisoDeuda}}</div>
                        <div class="col-12">
                            <p>
                                Tiene {{miFacturacion?.facturasVencidas}} factura(s) vencida(s) por
                                <b>{{deudaVencida | montoDinero: miFacturacion?.moneda}}</b>,
                                con hasta {{diasDeAtrasoMaximo}} días de atraso.

                                <ng-container *ngIf="miFacturacion?.nivelMora === 'CORTE_INMINENTE'">
                                    Su cuenta de {{nameCompany}} puede ser suspendida en cualquier momento.
                                    Regularice el pago hoy mismo.
                                </ng-container>
                                <ng-container *ngIf="miFacturacion?.nivelMora === 'URGENTE'">
                                    De no regularizarlo, el servicio se suspenderá en
                                    {{miFacturacion?.diasParaCorte}} día(s).
                                </ng-container>
                                <ng-container *ngIf="miFacturacion?.nivelMora === 'AVISO'">
                                    Cuenta con {{miFacturacion?.diasParaCorte}} día(s) más antes de que
                                    el servicio se vea afectado.
                                </ng-container>

                                Puede ver el detalle en <a routerLink="/facturacion">Facturación</a>.
                            </p>
                        </div>
                    </div>
                </ng-template>
            </p-messages>
        </div>
        <div class="layout-content">
            <router-outlet></router-outlet>
        </div>

        <app-footer></app-footer>

        <app-ai-chat></app-ai-chat>

       <!-- <app-config></app-config>-->

        <div class="layout-main-mask"></div>

        <div class="layout-config-mask" *ngIf="configActive" [@mask-anim]="'visible'"></div>
    </div>
</div>
